import React from 'react';

import { MenuRecentItems } from 'components/menu-tile-grid/menu-recent-items';
import useMediaQuery from 'hooks/use-media-query';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { MenuTile } from './menu-tile';
import MenuTileGridContainer, { MenuListGridContainer } from './menu-tile-grid-container';
import { IMenuTileGridProps } from './types';

const MenuTileGrid = React.memo(
  ({ className, data = [], gridTitle, objectFitContain = false }: IMenuTileGridProps) => {
    const useEnableMenuListUI = useFlag(LaunchDarklyFlag.ENABLE_MENU_LIST_UI);
    const useEnableTabbedMenuBar = useFlag(LaunchDarklyFlag.ENABLE_TABBED_MENU_BAR);
    const enableMenuServiceData = useFlag(LaunchDarklyFlag.ENABLE_MENU_SERVICE_DATA);

    const isMobile = useMediaQuery('mobile');
    const shouldRenderRecentItems = useEnableTabbedMenuBar ? !isMobile : true;

    const Container = useEnableMenuListUI ? MenuListGridContainer : MenuTileGridContainer;

    return (
      <>
        {shouldRenderRecentItems && <MenuRecentItems />}
        <Container
          className={className}
          data-testid="menu-tile-grid"
          $noPaddingTop={useEnableTabbedMenuBar}
        >
          {gridTitle && <h3>{gridTitle}</h3>}
          <MenuTile
            objectFitContain={objectFitContain}
            menuData={data}
            enableMenuList={useEnableMenuListUI}
            enableMenuServiceData={enableMenuServiceData}
          />
        </Container>
      </>
    );
  }
);

export default MenuTileGrid;
